import helpers from './helpers'
import CustomerService from '@/services/API/CustomerService'
import { objectIsEmpty } from '@/services/JSUtils'
import { cloneDeep } from 'lodash'

const setCustomerData = ({ dispatch, commit, rootGetters }, customerData) => {
    if (objectIsEmpty(customerData)) dispatch('setAvailableDiscounts', [])
    // commit('SET_CUSTOMER_DATA', null)
    // setTimeout(() => {
    //     commit('SET_CUSTOMER_DATA', customerData)
    //     const activeTransaction =
    //         rootGetters['TransactionModule/activeTransaction']
    //     const dataStatus = helpers.validateData(customerData, activeTransaction)
    //     commit('SET_DATA_STATUS', dataStatus)
    // }, 50)
    commit('SET_CUSTOMER_DATA', customerData)
    const activeTransaction = rootGetters['TransactionModule/activeTransaction']
    const dataStatus = helpers.validateData(customerData, activeTransaction)
    commit('SET_DATA_STATUS', dataStatus)
}

const setCustomerID = ({ commit }, customerID) => {
    commit('SET_CUSTOMER_ID', customerID)
}

const fetchCustomerData = async (
    { dispatch, rootState, rootGetters },
    attrObject
) => {
    let promise =
        attrObject.field === 'id'
            ? CustomerService.find(
                  attrObject.value,
                  attrObject.fetchMissingData,
                  attrObject.groundSellerId || null
              )
            : CustomerService.findByKey(attrObject)
    let timeout = new Promise((resolve, reject) => {
        setTimeout(() => reject('Tiempo de espera agotado'), 30000)
    })
    return new Promise((resolve, reject) =>
        Promise.race([promise, timeout])
            .then(customer => {
                if (!objectIsEmpty(customer)) {
                    if (customer.blocked_sales) resolve('block')
                    customer.active_core_business_id =
                        customer.main_g_core_business_sii_id || null
                    dispatch('setCustomerData', customer)
                    dispatch('setCustomerID', customer.id)
                    let discounts = customer.discount
                    if (!Array.isArray(discounts)) discounts = [discounts]
                    dispatch('setAvailableDiscounts', discounts)
                    if (rootGetters['AuthModule/isGroundSeller'])
                        dispatch(
                            'CartModule/setCartItems',
                            cloneDeep(rootState.CartModule.items),
                            { root: true }
                        )
                    resolve(true)
                }
            })
            .catch(reject)
    )
}

const fetchCustomerDataOld = async (
    { dispatch, rootState, rootGetters },
    attrObject
) => {
    let customer = {}
    if (attrObject.field === 'id') {
        customer = await CustomerService.find(
            attrObject.value,
            attrObject.fetchMissingData
        )
    } else {
        customer = await CustomerService.findByKey(attrObject)
    }
    if (!objectIsEmpty(customer)) {
        if (customer.blocked_sales) return 'block'
        customer.active_core_business_id =
            customer.main_g_core_business_sii_id || null
        dispatch('setCustomerData', customer)
        dispatch('setCustomerID', customer.id)
        let discounts = customer.discount
        if (!Array.isArray(discounts)) discounts = [discounts]
        dispatch('setAvailableDiscounts', discounts)
        if (rootGetters['AuthModule/isGroundSeller'])
            dispatch(
                'CartModule/setCartItems',
                cloneDeep(rootState.CartModule.items),
                { root: true }
            )
        return true
    }
    return false
}

const setAvailableDiscounts = ({ dispatch, commit }, discountsArray) => {
    if (discountsArray.length == 0) dispatch('setClientDiscount', null)
    commit('SET_AVAILABLE_DISCOUNTS', discountsArray)
}

const checkDataStatus = ({ commit, state, rootGetters }) => {
    const customerData = state.customerData
    const activeTransaction = rootGetters['TransactionModule/activeTransaction']
    const dataStatus = helpers.validateData(customerData, activeTransaction)
    commit('SET_DATA_STATUS', dataStatus)
}

const toggleCreateMode = ({ commit }, bool) => {
    commit('TOGGLE_CREATE_MODE', bool)
}

const setClientDiscount = ({ commit }, percentage) => {
    commit('SET_CLIENT_DISCOUNT', percentage)
}

const setActiveOffice = ({ commit }, officeID) => {
    commit('SET_ACTIVE_OFFICE', officeID)
}

const resetState = function({ commit }) {
    commit('RESET_STATE')
}

export default {
    resetState,
    setCustomerData,
    checkDataStatus,
    fetchCustomerData,
    toggleCreateMode,
    setCustomerID,
    setAvailableDiscounts,
    setClientDiscount,
    setActiveOffice,
}
